module.exports = __webpack_public_path__ + "static/media/es.abd0e7b3.svg";